function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1689 8.79136L11.8974 0.519844C11.2089 -0.168684 9.99709 -0.177864 9.29938 0.519844L1.03705 8.78218C0.320983 9.49824 0.320983 10.655 1.03705 11.371L9.29938 19.6334C9.65742 19.9914 10.1256 20.1658 10.5938 20.1658C11.062 20.1658 11.5302 19.9914 11.8882 19.6334L20.1414 11.3802C20.8666 10.6825 20.8758 9.52579 20.1689 8.79136ZM10.603 18.3389L2.34066 10.0766L10.603 1.81428L18.8653 10.0766L10.603 18.3389ZM6.92167 9.16775V12.8399H8.75774V10.0858H12.4299V12.3809L15.643 9.16775L12.4299 5.95462V8.24971H7.8397C7.33478 8.24971 6.92167 8.66283 6.92167 9.16775Z",
  fill: "#20205D"
});

var SvgDirections = function SvgDirections(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDirections, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/directions.ad8f1be9.svg";
export { ForwardRef as ReactComponent };